import { useContext } from 'react';
import { Link } from 'react-router-dom';
import ProgramsTable from './ProgramsTable/ProgramsTable';
import { IProgramsListContext, ProgramsListContext } from '../../../../application/context/Programs/ProgramsList/ProgramsListContext';
import Filter from './Filter/Filter';

export default function Programs() {
    const { state } = useContext<IProgramsListContext>(ProgramsListContext);
    const { data: programs } = state.getProgramsState;

  return (
    <div>
         <div className="d-lg-flex d-md-flex d-sm-flex justify-content-between align-items-center text-lg-left text-md-left text-sm-left text-center mt-5">
            <div className="w-100 mt-2">
                <Filter />
            </div>

            <div className="ml-5">
                <Link to="/admin/dashboard/settings/programs/create">
                    <div className="bg-white py-2 px-2" style={{borderRadius: '2rem'}}>
                        <svg className="icon icon-gray" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
                    </div>
                </Link>
            </div>
        </div>
        
        {programs.length > 0 ? (
            <div className="mt-4">
                <ProgramsTable />
            </div>
        ) : (
            <div className="mt-5">
                <span>No se han encontrado programas</span>
            </div>
        )}
    </div>
  )
}
